import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import connect from '../../../utils/connect';
import filterActions from '../../../actions/filters';

import {
    getOrderByOptions,
    getSortByOptions,
} from '../../../social-media-posts/dropdownOptions';

import { useFormikContext } from 'formik';
import { Typography, Flex, Select, theme } from '@app/ui';
import { FiltersFormContext } from './FiltersFormContext';

const SortByRow = ({ sendNotifications }) => {
    const { t } = useTranslation();
    const [canSetDefault, setCanSetDefault] = useState(false);
    const { values, setFieldValue } = useFormikContext();
    const { isOverridingFilters } = useContext(FiltersFormContext);

    const setDefaultSort = () => {
        localStorage.setItem('smpSort', values.sort);
        localStorage.setItem('smpOrder', values.order);
        setCanSetDefault(false);
        sendNotifications(t('filters.defaultSortByUpdated'));
    };

    const selectSort = useCallback(selected => {
        setFieldValue('sort', selected, false);
        setCanSetDefault(true);
    }, []);

    const selectOrderBy = useCallback(selected => {
        setFieldValue('order', selected, false);
        setCanSetDefault(true);
    }, []);

    const sortOptions = React.useMemo(
        () =>
            getSortByOptions(t).map(option => ({
                value: option.value,
                label: option.name,
            })),
        [t],
    );

    const orderOptions = React.useMemo(
        () =>
            getOrderByOptions(t, values.sort).map(option => ({
                value: option.value,
                label: option.name,
            })),
        [t, values.sort],
    );

    const {
        token: { colorPrimary },
    } = theme.useToken();

    return (
        <Flex gap={12} flex={1}>
            <Flex vertical flex={1} gap={4}>
                <Typography.Text className="-filter-title">
                    {t('filters.sortBy')}
                </Typography.Text>
                {canSetDefault && !isOverridingFilters && (
                    <Typography.Link
                        onClick={setDefaultSort}
                        style={{
                            color: colorPrimary,
                            marginLeft: '12px',
                            fontSize: 12,
                            fontWeight: 600,
                        }}
                    >
                        {t('filters.setAsDefault')}
                    </Typography.Link>
                )}
                <Flex gap={8} wrap="wrap">
                    <Flex flex={1} wrap="wrap">
                        <Select
                            size="sm"
                            options={sortOptions}
                            onChange={selectSort}
                            customValue="value"
                            value={values.sort}
                            hideClearButton
                            disabled={isOverridingFilters}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                                width: '100%',
                            }}
                        />
                    </Flex>
                    <Flex flex={1} wrap="wrap">
                        <Select
                            size="sm"
                            options={orderOptions}
                            onChange={selectOrderBy}
                            customValue="value"
                            value={values.order}
                            hideClearButton
                            disabled={isOverridingFilters}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                                width: '100%',
                            }}
                        />
                    </Flex>
                </Flex>
            </Flex>
        </Flex>
    );
};

SortByRow.propTypes = {
    sendNotifications: PropTypes.func,
};

export default connect(['filters'], filterActions)(SortByRow);
